// extracted by mini-css-extract-plugin
export default {"container_head":"container_head___KF3hf","container":"container___U6FFJ","container_head_title":"container_head_title___ew1pu","container_head_bot":"container_head_bot___qbLec"};